/**
 * 組合員の声管理入力情報VO
 *
 */
export class MembersVoiceInputDataModel {

  /**
   * 受付番号
   */
  public receiptNum: string = <string>'';

  /**
   * 組合員名（漢字）
   */
  public correctMemberName: string = <string>'';

  /**
   * 匿名希望者
   */
  public correctAnonymous: string = <string>'';

  /**
   * 使用名称
   */
  public centerCoopDiv: string = <string>'1';

  /**
   * センター名
   */
  public centerName: string = <string>'';

  /**
   * 問合せ内容
   */
  public correctInquiryContents: string = <string>'';

}
